import { Fragment } from 'react'
import PropTypes from 'prop-types'

import Popover from 'components/common/Popover'
import CardTooltip from 'components/common/CardTooltip'
import Text from 'components/common/Text'
import Icon from 'components/Icon'
import SvgWarning from 'components/icons/Warning'

const InfoTooltip = ({ type = 'info', text, svgIconStyle = {}, ...props }) => (
  <Popover>
    {({ getTargetProps, getPopoverProps }) => (
      <Fragment>
        {type === 'warning' ? (
          <div
            {...getTargetProps({
              css: {
                cursor: 'pointer',
                width: '1em',
                height: '1em'
              },
              ...props
            })}
          >
            <SvgWarning css={svgIconStyle} />
          </div>
        ) : (
          <Icon
            icon="info"
            {...getTargetProps({
              css: {
                cursor: 'pointer'
              },
              ...props
            })}
          />
        )}
        <CardTooltip
          displayArrow
          size="small"
          variation="dark"
          {...getPopoverProps({
            css: {
              maxWidth: 250
            }
          })}
        >
          <Text as="small" css={{ color: 'white' }}>
            {text}
          </Text>
        </CardTooltip>
      </Fragment>
    )}
  </Popover>
)

InfoTooltip.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  type: PropTypes.string,
  svgIconStyle: PropTypes.object
}

export default InfoTooltip
